import { TEST_SIGNAL_PATHS, type TestSignalPath } from "@visioni/a3s-monitoring/app";

export interface TestSignalAction {
  signalPath: TestSignalPath;
  title: string;
  subtitle: string;
}

const ACTIONS: Readonly<Record<TestSignalPath, TestSignalAction>> = {
  camera: {
    signalPath: "camera",
    title: "Send Camera Test Signal",
    subtitle: "The camera uploads a clip to a3s, as it would for a real alarm.",
  },
  va: {
    signalPath: "va",
    title: "Send VA Test Signal",
    subtitle: "Exercises the VA delivery leg. Does nothing on a camera without VA.",
  },
};

/** One action per delivery leg, in the order the wire contract lists them. */
export const TEST_SIGNAL_ACTIONS: readonly TestSignalAction[] = TEST_SIGNAL_PATHS.map((path) => ACTIONS[path]);
